var _circle, _rect, _rect2, _rect3, _circle2, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTxSuccess(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 120,
    height: 120,
    viewBox: "0 0 120 120",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 60,
    cy: 60,
    r: 60,
    fill: "#E8EDEF"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 32,
    y: 29,
    width: 56,
    height: 67,
    rx: 6,
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 44,
    y: 68,
    width: 32,
    height: 6,
    rx: 3,
    fill: "#E8EDEF"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 44,
    y: 79,
    width: 20,
    height: 6,
    rx: 3,
    fill: "#E8EDEF"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 85,
    cy: 33,
    r: 11,
    fill: "#F8F8F8"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M83.9999 17C75.1634 17 68 24.1634 68 32.9999C68 41.8366 75.1634 49 83.9999 49C92.8366 49 100 41.8366 100 32.9999C100 24.1634 92.8366 17 83.9999 17ZM93.5803 28.6131L83.3415 39.5514L83.3413 39.5517C82.8691 40.0561 82.1494 40.1348 81.6 39.7882C81.4982 39.7238 81.4023 39.6449 81.3149 39.5517C81.3147 39.5515 81.3147 39.5515 81.3147 39.5515L75.4196 33.2538C74.8601 32.6561 74.8601 31.6868 75.4196 31.0889C75.9792 30.4911 76.8865 30.4911 77.446 31.0889L82.3282 36.3044L91.5539 26.4483C92.1137 25.8506 93.0209 25.8506 93.5805 26.4483C94.1399 27.0461 94.1399 28.0153 93.5803 28.6131Z",
    fill: "#12B89A"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTxSuccess);
export default __webpack_public_path__ + "static/media/txSuccess.e59af82776ee99ca9f4bd95bdbbb1514.svg";
export { ForwardRef as ReactComponent };